module.exports = __webpack_public_path__ + "montserrat-bold-webfont.b5f841ee2ea8d46512cb.woff";


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/src/assets/fonts/montserrat-bold-webfont.woff
// module id = ../../../../../src/assets/fonts/montserrat-bold-webfont.woff
// module chunks = 1